export default "__VITE_ASSET__BhioCyVN__"